import { useState } from 'react';
import { removeDangerousSpecialCharacters } from 'modules/utils/removeDangerousSpecialCharacters';

function useNameInput() {
  const [nameInput, setNameInput] = useState<string | undefined>();
  const [nameInputError, setNameInputError] = useState<boolean>(false);
  const handleNameInputAdd = (event: React.ChangeEvent<HTMLInputElement> | undefined) => {
    if (event) {
      const nameInputWithDangerousCharactersRemoved = removeDangerousSpecialCharacters(
        event.target.value
      );
      setNameInput(nameInputWithDangerousCharactersRemoved);
      setNameInputError(false);
    }
  };
  return {
    nameInput,
    nameInputError,
    onNameInputAdd: handleNameInputAdd,
    onNameInputError: setNameInputError,
  };
}

export default useNameInput;
